/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import DiscussionsSearchSource from 'flarum/forum/components/DiscussionsSearchSource';
import UsersSearchSource from 'flarum/forum/components/UsersSearchSource';
import icon from 'flarum/common/helpers/icon';
import highlight from 'flarum/common/helpers/highlight';
import extractText from 'flarum/common/utils/extractText';
import { childIndex, type VdomParent } from '../../common/utils/vdom';
import type Mithril from 'mithril';

const headerClass = 'Dropdown-header';

/**
 * A search result vnode whose `children` are rewritten in place.
 */
export interface SearchResultVnode {
	children?: Mithril.Children;
}

function addIconAndHighlight(vdom: Mithril.Vnode[], query: string, iconName: string) {
	try {
		// `childIndex()` returns `false` when nothing matches; the surrounding
		// `try` swallows the resulting access on `undefined`, as before.
		const headerIndex = childIndex(vdom as unknown as VdomParent, headerClass) as number;
		vdom[headerIndex] = (
			<li className={headerClass}>
				{icon(iconName)} {vdom[headerIndex].text}
			</li>
		);

		const searchLinkItem = vdom[headerIndex + 1] as SearchResultVnode;
		const searchLinkContent = (searchLinkItem.children as SearchResultVnode[])[0];

		// it seems to be, that the search action elements have 3 children, the others have 2
		if ((searchLinkContent.children as Mithril.Children[]).length === 3) {
			searchLinkContent.children = highlight(extractText(searchLinkContent.children), query);
		}
	} catch (error) {}
}

export default function () {
	extend(DiscussionsSearchSource.prototype, 'view', function (vdom, query) {
		addIconAndHighlight(vdom, query, 'far fa-comments');
	});
	extend(UsersSearchSource.prototype, 'view', function (vdom, query) {
		addIconAndHighlight(vdom, query, 'far fa-users');
	});
}
